<sf-post-search [isCollapsed]="true"></sf-post-search>
<sf-card>
    @if (postsStore.newPostReceivedCounter() > 0) {
        <div class="text-light bg-danger p-2 text-center mb-3">
            <p class="mb-0 fw-bold">
                You have received {{ postsStore.newPostReceivedCounter() }} posts!
                <button
                    sfButton
                    type="button"
                    color="light"
                    size="sm"
                    icon="refresh"
                    class="ms-3"
                    (click)="reloadPosts()">
                    Reload
                </button>
            </p>
        </div>
    }
    <div class="d-flex flex-column flex-md-row mb-3 align-items-md-center">
        <div>
            <div class="d-flex gap-1 mb-2 mb-md-0 justify-content-center">
                <span class="badge text-bg-primary"
                    >{{ appStore.postCounter().postsToProcessCount }} posts to process</span
                >
                <span class="badge text-bg-danger"
                    >{{ appStore.postCounter().urgentPostsToProcessCount }} urgent posts to process</span
                >
            </div>
        </div>
        <div class="ms-md-auto">
            <div class="d-grid d-md-inline-flex g-2 gap-1">
                @if (postsStore.filter().inChargeStaffId !== appStore.me()?.id) {
                    <button
                        sfButton
                        color="secondary"
                        size="sm"
                        icon="user-check"
                        tooltip="Only show posts assigned to me"
                        (click)="onlyMine()">
                        Assigned to me
                    </button>
                } @else {
                    <button
                        sfButton
                        color="secondary"
                        size="sm"
                        icon="user-check"
                        tooltip="Only show assigned and unassigned posts"
                        (click)="showAssignedAndUnassigned()">
                        All Posts
                    </button>
                }

                <button
                    sfButton
                    color="secondary"
                    size="sm"
                    icon="refresh"
                    tooltip="Reload the the posts"
                    (click)="reloadPosts()">
                    Reload

                    @if (postsStore.newPostReceivedCounter() > 0) {
                        <span class="badge text-bg-danger">{{ postsStore.newPostReceivedCounter() }}</span>
                    }
                </button>
            </div>
        </div>
    </div>

    @if (postsStore.postsPaged(); as postsPaged) {
        @for (post of postsStore.entities(); track post.id) {
            <sf-post-detail [post]="post" (onPostClick)="onPostClick($event)" (onViewCertificate)="viewCertificate($event)"></sf-post-detail>
        }

        @if (!postsPaged.items.length) {
            <sf-empty message="There are no posts, amend your search criteria and search again"></sf-empty>
        }

        <sf-pagination-detail [paginationData]="postsPaged" (onPageChange)="pageChanged($event)"></sf-pagination-detail>
    }
</sf-card>
